import React, { useEffect, useState } from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ErrorBoundary from '../ErrorBoundary';

import LogicJump from './LogicJump';

const LogicDialog = (props) => {
    const [logicIdx, setLogicIdx] = useState(-1);
    const [errorMessage, setErrorMessage] = useState(null);
    const { open, toggleOpen, logic, field, fields, thankyou_screens, welcome_screens, position, handleDelete, addLogicJump, setChoice, setYesNo, setJumpTo, addAlwaysJump, setOp } = props;

    useEffect(() => {
        findLogic();
    }, [props.logic.length]) // eslint-disable-line

    function findLogic() {
        let logicIdx = logic.findIndex(jump => jump.ref === field.ref);
        setLogicIdx(logicIdx);
    }

    function handleToggle() {
        if (logic[logicIdx] && field.type === 'multiple_choice') {
            let choiceNotSelected = logic[logicIdx].actions.some(action => {
                if(action.condition.vars[1]) return action.condition.vars[1].value === null;
                return false;
            });
            if (choiceNotSelected) {
                setErrorMessage("Error: Select choice before closing")
                return;
            }
        }
        toggleOpen();
    }

    function containsAlways(actions) {
        return actions.some(action => action.condition.op === 'always');
    }

    return (
        <Dialog
            open={open}
            onClose={handleToggle}
            fullWidth={true}
            maxWidth={"md"}
        >
            <ErrorBoundary>
                <DialogTitle id="logic-jump-title"> {`Logic Jump`}</DialogTitle>
                <DialogContent>
                    <p>{`${position + 1}. ${field.title}`}</p>
                    {errorMessage &&
                        <p style={{ color: '#ff0033', fontSize: 16, fontWeight: 'bold' }}> {errorMessage} </p>
                    }
                    {(logicIdx !== -1) &&
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {logic[logicIdx].actions.map((action, idx) => {
                                return (
                                    <div key={idx}>
                                        <LogicJump
                                            action={action}
                                            field={field}
                                            fields={fields}
                                            welcome_screens={welcome_screens}
                                            thankyou_screens={thankyou_screens}
                                            logicIdx={logicIdx}
                                            idx={idx}
                                            handleDelete={handleDelete}
                                            setChoice={setChoice}
                                            setOp={setOp}
                                            setJumpTo={setJumpTo}
                                            setYesNo={setYesNo}
                                            setErrorMessage={setErrorMessage}
                                        />
                                    </div>
                                )
                            })}
                            {!containsAlways(logic[logicIdx].actions) &&
                                <div>
                                    <LogicJump
                                        action={alwaysAction}
                                        field={field}
                                        fields={fields}
                                        welcome_screens={welcome_screens}
                                        thankyou_screens={thankyou_screens}
                                        logicIdx={logicIdx}
                                        setJumpTo={setJumpTo}
                                        setErrorMessage={setErrorMessage}
                                        addAlwaysJump={addAlwaysJump}
                                    />
                                </div>
                            }
                        </div>
                    }
                    <Tooltip title="Add Logic Jump" placement="top" arrow>
                        <IconButton onClick={() => addLogicJump(logicIdx, field.type, field.ref)}>
                            <AddCircleIcon fontSize="default" />
                        </IconButton>
                    </Tooltip>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleToggle} color="primary">
                        Close
                </Button>
                </DialogActions>
            </ErrorBoundary>
        </Dialog>
    )
};

const alwaysAction = {
    action: "jump",
    condition: {
        op: "always",
        vars: []
    },
    details: {
        to: {
            type: "field",
            value: ""
        }
    }
}

export default LogicDialog;